import React from "react";
import PropTypes from "prop-types";

/**
 * Wrapper
 *  - Wrapper for GroupD
 */
export function Wrapper(props) {
  return <div className={props.className}>{props.children}</div>;
}

Wrapper.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   *  Child components to render in Step
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

Wrapper.defaultProps = {
  className: "",
};
